export default __webpack_public_path__ + "static/media/635.4e21e077.gif";